var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageInfo64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconInfo64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Icons/pictograms/picto-ui-info-32-Copy-3",
    fill: "#0063FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.326888 64,32 C63.9798462,49.6647573 49.6647573,63.9798462 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 Z M32,4.57142857 C16.8516183,4.57142857 4.57142857,16.8516183 4.57142857,32 C4.57142857,47.1483817 16.8516183,59.4285714 32,59.4285714 C47.1483817,59.4285714 59.4285714,47.1483817 59.4285714,32 C59.4121946,16.858407 47.141593,4.58780537 32,4.57142857 Z M32.0548571,23.552 C34.1942857,23.552 35.9497143,25.3074286 35.9497143,27.3371429 L35.9497143,27.3371429 L35.9497143,49.0605714 C35.9497143,51.1451429 34.1942857,52.8457143 32.0548571,52.8457143 C29.8605714,52.8457143 28.16,51.1451429 28.16,49.0605714 L28.16,49.0605714 L28.16,27.3371429 C28.16,25.3074286 29.8605714,23.552 32.0548571,23.552 Z M32.0548571,12.1965714 C34.6331429,12.1965714 36.6628571,14.1714286 36.6628571,16.6948571 C36.6628571,19.2182857 34.6331429,21.3028571 32.0548571,21.3028571 C29.4217143,21.3028571 27.3371429,19.2182857 27.3371429,16.6948571 C27.3371429,14.1714286 29.4217143,12.1965714 32.0548571,12.1965714 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageInfo64);
export default __webpack_public_path__ + "static/media/messageInfo64.39a90a30e3eabd249a42a759a41dee90.svg";
export { ForwardRef as ReactComponent };